


































import { Vue, Prop, Component } from 'vue-property-decorator'

@Component
export default class DialogPrompt extends Vue {
  @Prop({ type: Boolean }) isShowDialog?: boolean
  @Prop({ type: String }) title?: string
  @Prop({ type: String }) subtitle?: string
  @Prop({ type: String }) confirmText?: string
  @Prop({ type: Boolean, default: true }) hasErrorIcon?: boolean
  @Prop({ type: String }) cancelText?: string
  @Prop({ type: String }) confirmButtonBackgroundColor?: string
  @Prop({ type: String }) iconLink?: string
  @Prop({ type: String }) messageTextColor?: string
  @Prop({ type: String }) confirmButtonTextColor?: string
  @Prop({ type: String }) confirmButtonBackgroundLink?: string
  @Prop({ type: String }) backgroundColor?: string
  @Prop({ type: String }) backgroundLink?: string

  confirmHandler() {
    this.$emit('confirm')
  }
  cancelHandler() {
    this.$emit('cancel')
  }
}
